export interface RecordAction {
  readonly code: string;
  readonly name: string;
}

export interface JournalRecord<TypeId = string> {
  id: TypeId;
  actions?: RecordAction[];
}
